import React from "react"
import styled from "styled-components"
import colors from "../../styles/colors"
import breakpoints from "../../styles/breakpoints"

const IndicatorStyled = styled.div`
    margin-bottom: 15px;
    margin-top: 15px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    
    span {
        &:hover {
          cursor: pointer;
        }
    }
    
    @media(min-width: ${breakpoints.xl}) {
        display: none;
    }
`;

const DotStyled = styled.div`
    z-index: 500;
    height: 14px;
    width: 14px;
    cursor: pointer;
    background: ${props => props.$active === true ? `${colors.white}` : 'transparent'};
    border-radius: 50px;
    position: relative;
    margin-left: ${props => props.$isFirst === 'true' ? '0' : '16px'};
    &::before {
      content: '';
      height: 14px;
      width: 14px;
      cursor: pointer;
      border: 1px solid transparent;
      border-color: ${props => props.$active === true && `${colors.green}`};
      border-radius: 50px;
      position: absolute;
      top: 0;
      left: 0;
      transition: 0.2s;
      z-index: 100;
    }
    &::after {
      content: '';
      height: 8px;
      width: 8px;
      z-index: 50;
      background: ${props => props.$active === true ? `${colors.green}` : '#C8C8C8'};
      cursor: pointer;
      border: 1px solid transparent;
      border-radius: 50px;
      position: absolute;
      top: 3px;
      left: 3px;
      transition: 0.2s;
    }
`;

const CarouselIndicator = (props) => {
  const {current, max, className, changeSlide} = props;
  let dots = [...Array(max).keys()];

  let handleChange = changeSlide;
  if (changeSlide === undefined) {
    handleChange = () => {}
  }

  return (
    <IndicatorStyled className={className}>
      {dots.map((dot, index) =>
        <DotStyled key={index} $active={current === index ? 1 : 0} onClick={() => handleChange(index)} $isFirst={index === 0 ? 'true' : 'false'}/>
      )}
    </IndicatorStyled>
  );
};

export default CarouselIndicator;
